// extracted by mini-css-extract-plugin
export default {"status":"yH29B0duZfhS3jSFAwxJ"};